// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_1t-3";
export var dialog = "_1t-0";
export var divClassnameSwatch = "_1t-8";
export var flexSwatch = "_1t-4";
export var header = "_1t-1";
export var styleAttributeSwatch = "_1t-7";
export var swatch = "_1t-2";
export var textHeaderSwatch = "_1t-5";
export var webSwatch = "_1t-6";